import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const HowToMarketplacePage = () => {
    const { t } = useTranslation();

    const steps = [
        {
            id: 1,
            title: t('howToMarketplace.step1.title', 'Go to Marketplace & Create Listing'),
            desc: t('howToMarketplace.step1.desc', 'Navigate to the Marketplace and click "List a Card" or "Sell".'),
            imagePath: "", // No specific image for now, maybe use a generic one or none
            imagePlaceholder: "Screenshot of Marketplace Sell Button"
        },
        {
            id: 2,
            title: t('howToMarketplace.step2.title', 'Get Facebook Post Link'),
            desc: t('howToMarketplace.step2.desc', 'If you have a Facebook post for your item, tap "Share" on your post.'),
            imagePath: "/images/how-to/step2.png", // Reused from Report Price
            imagePlaceholder: "Tap Share on Facebook"
        },
        {
            id: 3,
            title: t('howToMarketplace.step3.title', 'Copy Link'),
            desc: t('howToMarketplace.step3.desc', 'Select "Copy Link" to get the URL of your post.'),
            imagePath: "/images/how-to/step3.png", // Reused from Report Price
            imagePlaceholder: "Tap Copy Link"
        },
        {
            id: 4,
            title: t('howToMarketplace.step4.title', 'Fill Details & Submit'),
            desc: t('howToMarketplace.step4.desc', 'Paste the link in the "External Link" field, set your price and quantity, then submit.'),
            imagePath: "",
            imagePlaceholder: "Screenshot of Create Listing Form"
        }
    ];

    return (
        <div className="container mx-auto px-4 py-8">
            <div className="text-center mb-12">
                <h1 className="text-4xl font-bold text-gray-900 mb-4">{t('howToMarketplace.title', 'How to List Item')}</h1>
                <p className="text-xl text-gray-600 max-w-2xl mx-auto">
                    {t('howToMarketplace.subtitle', 'Follow these steps to list your cards for sale or buy.')}
                </p>
            </div>

            <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto mb-16">
                {steps.map((step) => (
                    <div key={step.id} className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100 flex flex-col">
                        <div className="p-6 pb-4">
                            <h3 className="text-xl font-bold text-gray-800 mb-2">{step.title}</h3>
                            <p className="text-gray-600">
                                {step.desc}
                            </p>
                        </div>
                        {step.imagePath && (
                            <div className="bg-gray-100 h-48 sm:h-64 flex items-center justify-center border-t border-gray-100 flex-grow overflow-hidden relative group">
                                <img
                                    src={step.imagePath}
                                    alt={step.title}
                                    className="w-full h-full object-contain p-2 transition-opacity duration-300"
                                    onError={(e) => {
                                        e.currentTarget.style.display = 'none';
                                        const parent = e.currentTarget.parentElement;
                                        if (parent) {
                                            const fallback = parent.querySelector('.fallback-placeholder') as HTMLElement;
                                            if (fallback) fallback.style.display = 'block';
                                        }
                                    }}
                                />
                                <div className="fallback-placeholder absolute inset-0 hidden p-4 flex flex-col items-center justify-center text-center">
                                    <svg className="w-12 h-12 text-gray-300 mx-auto mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                    </svg>
                                    <span className="text-gray-400 text-sm font-medium">{step.imagePlaceholder}</span>
                                </div>
                            </div>
                        )}
                    </div>
                ))}
            </div>

            <div className="text-center">
                <Link
                    to="/marketplace/sell"
                    className="inline-block bg-blue-600 text-white text-lg font-semibold px-8 py-3 rounded-full hover:bg-blue-700 transition shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
                >
                    {t('howToMarketplace.cta', 'Create Listing Now')}
                </Link>
            </div>
        </div>
    );
};

export default HowToMarketplacePage;
